export const PREFECTURES = [
    "Hokkaido",
    "Aomori",
    "Iwate",
    "Miyagi",
    "Akita",
    "Yamagata",
    "Fukushima",
    "Ibaraki",
    "Tochigi",
    "Gunma",
    "Saitama",
    "Chiba",
    "Tokyo",
    "Kanagawa",
    "Niigata",
    "Toyama",
    "Ishikawa",
    "Fukui",
    "Yamanashi",
    "Nagano",
    "Gifu",
    "Shizuoka",
    "Aichi",
    "Mie",
    "Shiga",
    "Kyoto",
    "Osaka",
    "Hyogo",
    "Nara",
    "Wakayama",
    "Tottori",
    "Shimane",
    "Okayama",
    "Hiroshima",
    "Yamaguchi",
    "Tokushima",
    "Kagawa",
    "Ehime",
    "Kochi",
    "Fukuoka",
    "Saga",
    "Nagasaki",
    "Kumamoto",
    "Oita",
    "Miyazaki",
    "Kagoshima",
    "Okinawa"
];

export const PREFECTURES_KANJI = [
    "北海道",  // Hokkaido
    "青森県",  // Aomori
    "岩手県",  // Iwate
    "宮城県",  // Miyagi
    "秋田県",  // Akita
    "山形県",  // Yamagata
    "福島県",  // Fukushima
    "茨城県",  // Ibaraki
    "栃木県",  // Tochigi
    "群馬県",  // Gunma
    "埼玉県",  // Saitama
    "千葉県",  // Chiba
    "東京都",  // Tokyo
    "神奈川県", // Kanagawa
    "新潟県",  // Niigata
    "富山県",  // Toyama
    "石川県",  // Ishikawa
    "福井県",  // Fukui
    "山梨県",  // Yamanashi
    "長野県",  // Nagano
    "岐阜県",  // Gifu
    "静岡県",  // Shizuoka
    "愛知県",  // Aichi
    "三重県",  // Mie
    "滋賀県",  // Shiga
    "京都府",  // Kyoto
    "大阪府",  // Osaka
    "兵庫県",  // Hyogo
    "奈良県",  // Nara
    "和歌山県", // Wakayama
    "鳥取県",  // Tottori
    "島根県",  // Shimane
    "岡山県",  // Okayama
    "広島県",  // Hiroshima
    "山口県",  // Yamaguchi
    "徳島県",  // Tokushima
    "香川県",  // Kagawa
    "愛媛県",  // Ehime
    "高知県",  // Kochi
    "福岡県",  // Fukuoka
    "佐賀県",  // Saga
    "長崎県",  // Nagasaki
    "熊本県",  // Kumamoto
    "大分県",  // Oita
    "宮崎県",  // Miyazaki
    "鹿児島県", // Kagoshima
    "沖縄県"   // Okinawa
];

export const PREFECTURE_REGIONS = [
    "Hokkaido",      // Hokkaido
    "Tohoku",        // Aomori
    "Tohoku",        // Iwate
    "Tohoku",        // Miyagi
    "Tohoku",        // Akita
    "Tohoku",        // Yamagata
    "Tohoku",        // Fukushima
    "Kanto",         // Ibaraki
    "Kanto",         // Tochigi
    "Kanto",         // Gunma
    "Kanto",         // Saitama
    "Kanto",         // Chiba
    "Kanto",         // Tokyo
    "Kanto",         // Kanagawa
    "Hokuriku",      // Niigata
    "Hokuriku",      // Toyama
    "Hokuriku",      // Ishikawa
    "Hokuriku",      // Fukui
    "Chubu",         // Yamanashi
    "Chubu",         // Nagano
    "Chubu",         // Gifu
    "Chubu",         // Shizuoka
    "Chubu",         // Aichi
    "Kansai/Chubu",        // Mie
    "Kansai",        // Shiga
    "Kansai",        // Kyoto
    "Kansai",        // Osaka
    "Kansai",        // Hyogo
    "Kansai",        // Nara
    "Kansai",        // Wakayama
    "Chugoku",       // Tottori
    "Chugoku",       // Shimane
    "Chugoku",       // Okayama
    "Chugoku",       // Hiroshima
    "Chugoku",       // Yamaguchi
    "Shikoku",       // Tokushima
    "Shikoku",       // Kagawa
    "Shikoku",       // Ehime
    "Shikoku",       // Kochi
    "Kyushu",        // Fukuoka
    "Kyushu",        // Saga
    "Kyushu",        // Nagasaki
    "Kyushu",        // Kumamoto
    "Kyushu",        // Oita
    "Kyushu",        // Miyazaki
    "Kyushu",        // Kagoshima
    "Okinawa"        // Okinawa
];

export const REGIONS_KANJI = [
    "北海道",  // Hokkaido
    "東北",    // Tohoku
    "関東",    // Kanto 
    "中部",    // Chubu - / 北陸 (Hokuriku) 
    "関西/近畿",    // Kansai - Alternate: 近畿 (Kinki)
    "中国",    // Chugoku
    "四国",    // Shikoku
    "九州・沖縄" // Kyushu/Okinawa
];

export const REGION_INDEX_TO_PREFECTURE_INDEX = [
    [0], [1], [2], [3], [4], [5], [6], [7], [8], [9], [10], [11], [12], [13], [14], [15], [16], [17], [18], [19],
    [20], [21], [22], [23], [24], [25], [26], [27], [28], [29], [30], [31], [32], [33], [34], [35], [36], [37],
    [38], [39], [40], [41], [42], [43], [44], [45], [46],
];
